import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import type { ITTDSubAdvertiser } from '@feathr/blackbox';
import { TanStackTable } from '@feathr/components';

import type { TAdvertiserSort } from './Advertisers.utils';
import {
  compareAdvertisers,
  getNextAdvertiserSort,
  INITIAL_ADVERTISER_SORT,
} from './Advertisers.utils';
import advertisersColumns from './advertisersColumns';

interface IAdvertisersProps {
  advertisers: ITTDSubAdvertiser[];
}

function Advertisers({ advertisers }: Readonly<IAdvertisersProps>): JSX.Element {
  const { t } = useTranslation();
  const [sort, setSort] = useState<TAdvertiserSort>(INITIAL_ADVERTISER_SORT);

  const columns = useMemo(() => advertisersColumns(t), [t]);
  const items = advertisers.slice().sort((a, b) => compareAdvertisers(a, b, sort));

  function handleSortChange(nextSort: TAdvertiserSort): void {
    setSort(getNextAdvertiserSort(nextSort));
  }

  return (
    <TanStackTable<ITTDSubAdvertiser>
      columns={columns}
      idKey={'subadv_id'}
      isPaginated={false}
      items={items}
      noDataText={t('No advertisers yet.')}
      onSortChange={handleSortChange}
      sort={sort}
    />
  );
}

export default observer(Advertisers);
